

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface TrainingClassParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface TrainingClass {
    id?: any;
    tenantId: any;
    branchId?: any;
    univ_Code?: string;
    name:any;
    description:string;
    trainingType:any;
    isActive:string;
    
    parameters?: TrainingClassParameter[];
    links?: any;
}


export abstract class TrainingClassData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<TrainingClass[]>;
    abstract create(url: string, data: TrainingClass): Observable<TrainingClass[]>;
    abstract update(url: string, data: TrainingClass): Observable<TrainingClass>;
    abstract delete(url: string): Observable<any>;
}
